import PropTypes from 'prop-types';
import { Container, Alert, AlertTitle, Box, Button, Typography } from '@mui/material';
import useAuth from 'hooks/useAuth';
import { styled } from '@mui/material/styles';
import Page from 'components/Page';
import LockIcon from '@mui/icons-material/Lock';
import { useNavigate } from 'react-router-dom';

// ----------------------------------------------------------------------

RoleBasedGuard.propTypes = {
  accessibleRoles: PropTypes.array, // Example ['admin', 'leader']
  children: PropTypes.node
};

const RootStyle = styled(Page)(({ theme }) => ({
  display: 'flex',
  minHeight: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

export default function RoleBasedGuard({ accessibleRoles, children }) {
  const { user } = useAuth();
  const navigate = useNavigate();

  if (!accessibleRoles.includes(user?.role)) {
    return (
      <RootStyle title="Permission Denied | Serviceplug">
        <Container>
          <Box sx={{ textAlign: 'center' }}>
            <LockIcon sx={{ mb: 5, mx: 'auto', fontSize: 160 }} color="error" />

            <Typography variant="h3" gutterBottom color="warn">
              Permission Denied
            </Typography>
            <AlertTitle>You do not have permission to access this page</AlertTitle>

            <Button size="large" variant="contained" onClick={() => navigate(-1)} sx={{ mt: 5 }}>
              Go Back
            </Button>
            {/* <Alert severity="error">
              <AlertTitle>Permission Denied</AlertTitle>
              You do not have permission to access this page
            </Alert> */}
          </Box>
        </Container>
      </RootStyle>
    );
  }

  return <>{children}</>;
}
